import { MtrRow } from './buildMtrRows';

function getColumns(): string[] {
  return ['Hop', 'Max RTT (ms)', 'Packet Loss', 'Host', 'Hostname', 'ASN', 'ASN Name', 'Location'];
}

function formatRtt(value: number | null): string {
  if (value == null || value <= 0) {
    return '*';
  }
  return value < 1 ? '<1' : value.toFixed(2);
}

function rowToValues(row: MtrRow): (string | number)[] {
  const lost = row.sent - row.recv;
  const lossPct = row.sent > 0 ? Math.round((lost / row.sent) * 100) : 0;
  const loss = `${lossPct}% (${lost}/${row.sent})`;
  const location = [row.city, row.country].filter(Boolean).join(', ') || '-';

  return [row.hop, formatRtt(row.maxRtt), loss, row.ip, row.hostname, row.asnId || '-', row.asnName || '-', location];
}

export function formatMtrClipboard(rows: MtrRow[]): string {
  if (!rows.length) {
    return '';
  }
  const columns = getColumns();
  const header = columns.join('\t');
  const body = rows.map((r) => rowToValues(r).join('\t')).join('\n');
  return `${header}\n${body}`;
}

export function getMtrCsvData(rows: MtrRow[]): { columns: string[]; data: (string | number)[][] } {
  if (!rows.length) {
    return { columns: [], data: [] };
  }
  return {
    columns: getColumns(),
    data: rows.map(rowToValues)
  };
}
